var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 54,
    viewBox: "0 0 186 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.35718,
    y: 0.5,
    width: 184.143,
    height: 53,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.35718,
    y: 0.5,
    width: 184.143,
    height: 53,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3008 29.3641C91.0752 29.3641 88.4462 31.7792 88.4462 35.1056C88.4462 38.4118 91.0752 40.8472 94.3008 40.8472C97.5278 40.8472 100.157 38.4118 100.157 35.1056C100.155 31.7792 97.5264 29.3641 94.3008 29.3641ZM94.3008 38.5873C92.533 38.5873 91.0094 37.1522 91.0094 35.107C91.0094 33.0401 92.5344 31.6267 94.3008 31.6267C96.0686 31.6267 97.5922 33.0401 97.5922 35.107C97.5922 37.1509 96.0686 38.5873 94.3008 38.5873ZM81.5273 29.3641C78.3017 29.3641 75.6727 31.7792 75.6727 35.1056C75.6727 38.4118 78.3017 40.8472 81.5273 40.8472C84.7543 40.8472 87.3833 38.4118 87.3833 35.1056C87.3833 31.7792 84.7543 29.3641 81.5273 29.3641ZM81.5273 38.5873C79.7595 38.5873 78.2359 37.1522 78.2359 35.107C78.2359 33.0401 79.7609 31.6267 81.5273 31.6267C83.2951 31.6267 84.8187 33.0401 84.8187 35.107C84.8201 37.1509 83.2951 38.5873 81.5273 38.5873ZM66.3346 31.1272V33.5626H72.2565C72.0795 34.9328 71.616 35.9332 70.9083 36.6284C70.0471 37.4762 68.699 38.4118 66.3346 38.4118C62.6894 38.4118 59.8395 35.5187 59.8395 31.9304C59.8395 28.3421 62.6894 25.4491 66.3346 25.4491C68.3013 25.4491 69.7371 26.2105 70.7973 27.1892L72.5431 25.4707C71.0619 24.0788 69.0967 23.0137 66.3346 23.0137C61.3413 23.0137 57.1433 27.0151 57.1433 31.9304C57.1433 36.8458 61.3413 40.8472 66.3346 40.8472C69.0295 40.8472 71.0633 39.9764 72.6528 38.3456C74.2875 36.7364 74.7963 34.4738 74.7963 32.6473C74.7963 32.083 74.7525 31.5605 74.6633 31.1258H66.3346V31.1272ZM128.471 33.0185C127.986 31.736 126.505 29.3641 123.478 29.3641C120.473 29.3641 117.976 31.6915 117.976 35.1056C117.976 38.324 120.451 40.8472 123.765 40.8472C126.437 40.8472 127.984 39.238 128.626 38.3024L126.638 36.997C125.975 37.9541 125.069 38.5846 123.765 38.5846C122.462 38.5846 121.533 37.9973 120.937 36.8444L128.736 33.6692L128.471 33.0185ZM120.517 34.9328C120.451 32.7134 122.263 31.5835 123.567 31.5835C124.583 31.5835 125.445 32.0843 125.733 32.8012L120.517 34.9328ZM114.177 40.5002H116.739V23.6239H114.177V40.5002ZM109.978 30.6479H109.89C109.315 29.9729 108.21 29.3641 106.819 29.3641C103.902 29.3641 101.229 31.8872 101.229 35.1286C101.229 38.347 103.902 40.8485 106.819 40.8485C108.211 40.8485 109.315 40.2397 109.89 39.5444H109.978V40.3706C109.978 42.5671 108.784 43.7416 106.863 43.7416C105.294 43.7416 104.322 42.6332 103.924 41.6977L101.693 42.6116C102.333 44.1331 104.034 46.0042 106.863 46.0042C109.868 46.0042 112.409 44.264 112.409 40.0223V29.7137H109.979V30.6479H109.978ZM107.04 38.5873C105.272 38.5873 103.792 37.1293 103.792 35.1286C103.792 33.1049 105.272 31.6267 107.04 31.6267C108.784 31.6267 110.155 33.1049 110.155 35.1286C110.155 37.1293 108.784 38.5873 107.04 38.5873ZM140.477 23.6239H134.345V40.5002H136.903V34.1066H140.475C143.312 34.1066 146.101 32.0857 146.101 28.8659C146.101 25.6462 143.313 23.6239 140.477 23.6239ZM140.543 31.7576H136.903V25.9729H140.543C142.456 25.9729 143.542 27.5321 143.542 28.8659C143.542 30.1727 142.456 31.7576 140.543 31.7576ZM156.358 29.3344C154.505 29.3344 152.587 30.1376 151.792 31.9183L154.064 32.8511C154.549 31.9183 155.454 31.6132 156.402 31.6132C157.725 31.6132 159.071 32.3948 159.093 33.784V33.9581C158.629 33.6976 157.636 33.3074 156.424 33.3074C153.976 33.3074 151.483 34.6318 151.483 37.1063C151.483 39.3649 153.49 40.8188 155.739 40.8188C157.459 40.8188 158.408 40.0588 159.003 39.1678H159.091V40.4705H161.563V34C161.564 31.0057 159.29 29.3344 156.358 29.3344ZM156.048 38.5832C155.211 38.5832 154.042 38.1701 154.042 37.1495C154.042 35.8468 155.498 35.3473 156.756 35.3473C157.879 35.3473 158.41 35.5862 159.093 35.9116C158.894 37.4762 157.526 38.5832 156.048 38.5832ZM170.562 29.7029L167.628 37.0199H167.541L164.496 29.7029H161.739L166.305 39.9292L163.702 45.6181H166.371L173.408 29.7029H170.562ZM147.514 40.5002H150.071V23.6239H147.514V40.5002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8877 13.8278C65.8877 14.9591 65.5476 15.8596 64.866 16.5319C64.0925 17.3311 63.0831 17.7307 61.8433 17.7307C60.6557 17.7307 59.6449 17.3257 58.8152 16.5157C57.9841 15.7043 57.5686 14.6999 57.5686 13.5011C57.5686 12.301 57.9841 11.2966 58.8152 10.4866C59.6449 9.67521 60.6557 9.27022 61.8433 9.27022C62.4331 9.27022 62.9967 9.38362 63.5316 9.60907C64.0678 9.83587 64.4971 10.1369 64.818 10.5136L64.0952 11.2264C63.5508 10.5851 62.8006 10.2652 61.842 10.2652C60.9752 10.2652 60.2264 10.5649 59.5942 11.1643C58.962 11.7637 58.6465 12.5426 58.6465 13.4998C58.6465 14.4569 58.962 15.2359 59.5942 15.8353C60.2264 16.4347 60.9752 16.7344 61.842 16.7344C62.7608 16.7344 63.5275 16.4333 64.1405 15.8299C64.5382 15.437 64.7686 14.8903 64.8303 14.1896H61.842V13.2163H65.8287C65.8699 13.4282 65.8877 13.6321 65.8877 13.8278Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2101 10.4448H68.4634V13.0125H71.8426V13.9858H68.4634V16.5535H72.2101V17.5498H67.406V9.44984H72.2101V10.4448Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6685 17.5498H75.6111V10.4448H73.3126V9.44984H78.967V10.4448H76.6685V17.5498Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0579 17.5498V9.44984H84.1153V17.5498H83.0579Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8044 17.5498H87.747V10.4448H85.4485V9.44984H91.1029V10.4448H88.8044V17.5498Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.807 16.5036C100.997 17.3217 99.9922 17.7307 98.7895 17.7307C97.5867 17.7307 96.5815 17.3217 95.7737 16.5036C94.9645 15.6855 94.5613 14.6838 94.5613 13.4998C94.5613 12.3159 94.9645 11.3142 95.7737 10.4961C96.5815 9.67798 97.5867 9.26758 98.7895 9.26758C99.9853 9.26758 100.989 9.67933 101.801 10.5015C102.613 11.3236 103.019 12.3226 103.019 13.4998C103.019 14.6838 102.614 15.6855 101.807 16.5036ZM96.554 15.8245C97.1629 16.432 97.9076 16.7344 98.7895 16.7344C99.6713 16.7344 100.417 16.4307 101.025 15.8245C101.634 15.217 101.94 14.4421 101.94 13.4998C101.94 12.5575 101.634 11.7826 101.025 11.1751C100.417 10.5676 99.6713 10.2652 98.7895 10.2652C97.9076 10.2652 97.1629 10.569 96.554 11.1751C95.9465 11.7826 95.6407 12.5575 95.6407 13.4998C95.6407 14.4421 95.9465 15.217 96.554 15.8245Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.503 17.5498V9.44984H105.789L109.788 15.7503H109.834L109.788 14.1897V9.44984H110.846V17.5498H109.742L105.557 10.9429H105.512L105.557 12.5035V17.5498H104.503Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8877 13.8278C65.8877 14.9591 65.5476 15.8596 64.866 16.5319C64.0925 17.3311 63.0831 17.7307 61.8433 17.7307C60.6557 17.7307 59.6449 17.3257 58.8152 16.5157C57.9841 15.7043 57.5686 14.6999 57.5686 13.5011C57.5686 12.301 57.9841 11.2966 58.8152 10.4866C59.6449 9.67521 60.6557 9.27022 61.8433 9.27022C62.4331 9.27022 62.9967 9.38362 63.5316 9.60907C64.0678 9.83587 64.4971 10.1369 64.818 10.5136L64.0952 11.2264C63.5508 10.5851 62.8006 10.2652 61.842 10.2652C60.9752 10.2652 60.2264 10.5649 59.5942 11.1643C58.962 11.7637 58.6465 12.5426 58.6465 13.4998C58.6465 14.4569 58.962 15.2359 59.5942 15.8353C60.2264 16.4347 60.9752 16.7344 61.842 16.7344C62.7608 16.7344 63.5275 16.4333 64.1405 15.8299C64.5382 15.437 64.7686 14.8903 64.8303 14.1896H61.842V13.2163H65.8287C65.8699 13.4282 65.8877 13.6321 65.8877 13.8278Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2101 10.4448H68.4634V13.0125H71.8426V13.9858H68.4634V16.5535H72.2101V17.5498H67.406V9.44984H72.2101V10.4448Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6685 17.5498H75.6111V10.4448H73.3126V9.44984H78.967V10.4448H76.6685V17.5498Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0579 17.5498V9.44984H84.1153V17.5498H83.0579Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8044 17.5498H87.747V10.4448H85.4485V9.44984H91.1029V10.4448H88.8044V17.5498Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.807 16.5036C100.997 17.3217 99.9922 17.7307 98.7895 17.7307C97.5867 17.7307 96.5815 17.3217 95.7737 16.5036C94.9645 15.6855 94.5613 14.6838 94.5613 13.4998C94.5613 12.3159 94.9645 11.3142 95.7737 10.4961C96.5815 9.67798 97.5867 9.26758 98.7895 9.26758C99.9853 9.26758 100.989 9.67933 101.801 10.5015C102.613 11.3236 103.019 12.3226 103.019 13.4998C103.019 14.6838 102.614 15.6855 101.807 16.5036ZM96.554 15.8245C97.1629 16.432 97.9076 16.7344 98.7895 16.7344C99.6713 16.7344 100.417 16.4307 101.025 15.8245C101.634 15.217 101.94 14.4421 101.94 13.4998C101.94 12.5575 101.634 11.7826 101.025 11.1751C100.417 10.5676 99.6713 10.2652 98.7895 10.2652C97.9076 10.2652 97.1629 10.569 96.554 11.1751C95.9465 11.7826 95.6407 12.5575 95.6407 13.4998C95.6407 14.4421 95.9465 15.217 96.554 15.8245Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.503 17.5498V9.44984H105.789L109.788 15.7503H109.834L109.788 14.1897V9.44984H110.846V17.5498H109.742L105.557 10.9429H105.512L105.557 12.5035V17.5498H104.503Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4697_5508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1694 10.1767C14.7703 10.5925 14.5344 11.2378 14.5344 12.0734V41.93C14.5344 42.767 14.7703 43.411 15.1694 43.8268L15.2709 43.924L32.2615 27.1988V27.0017V26.8046L15.2709 10.0781L15.1694 10.1767Z",
    fill: "url(#paint0_linear_4697_5508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9241 32.776L32.2615 27.1992V27.0021V26.805L37.9255 21.2295L38.053 21.301L44.7634 25.054C46.6793 26.1259 46.6793 27.8796 44.7634 28.9528L38.053 32.7058L37.9241 32.776Z",
    fill: "url(#paint1_linear_4697_5508)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4697_5508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0531 32.7044L32.2602 27.002L15.1694 43.827C15.8003 44.4858 16.8439 44.5668 18.0193 43.9107L38.0531 32.7044Z",
    fill: "url(#paint2_linear_4697_5508)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.0531 21.2993L18.0193 10.0943C16.8439 9.43688 15.8003 9.51923 15.1694 10.178L32.2615 27.0031L38.0531 21.2993Z",
    fill: "url(#paint3_linear_4697_5508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4697_5508",
    x: 14.5344,
    y: 9.64062,
    width: 31.6659,
    height: 34.7236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4697_5508"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4697_5508",
    result: "effect2_innerShadow_4697_5508"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4697_5508",
    x: 15.1694,
    y: 27.002,
    width: 22.8837,
    height: 17.3623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4697_5508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4697_5508",
    x1: 30.7554,
    y1: 11.7575,
    x2: 8.10252,
    y2: 34.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4697_5508",
    x1: 47.2574,
    y1: 27.0021,
    x2: 14.0744,
    y2: 27.0021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4697_5508",
    x1: 34.9072,
    y1: 30.0987,
    x2: 4.18701,
    y2: 61.3065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4697_5508",
    x1: 10.8651,
    y1: 0.239057,
    x2: 24.5825,
    y2: 14.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.9ce04df99d633f2a96b85829716d3a0c.svg";
export { ForwardRef as ReactComponent };